import React from 'react';
import { BlockTypeButton } from './BlockTypeButton';
import { RichUtils, BlockMapBuilder, ContentBlock, genKey, CharacterMetadata, Modifier, EditorState, SelectionState } from 'draft-js';
import { getSelectedText, removeBlock } from 'lib/helpers';
import { List, Repeat, Map } from 'immutable';
import { setTimeout } from 'timers';

export function CodeBlockButton({ store, theme, disabled }) {
	const toggle = (actived) => {
		if (!actived) {
			combineToCodeBlock(store);
		}
		else {
			store.setEditorState(RichUtils.toggleBlockType(store.getEditorState(), 'code-block'));
		}
	};
	return (
		<BlockTypeButton toggle={toggle} store={store} theme={theme} disabled={disabled} blockType="code-block">
			<i className="qa-ico-code-block" title="代码块">&lt;&gt;</i>
		</BlockTypeButton>
	);
}

function combineToCodeBlock(store) {
	/** @type {Draft.EditorState} */
	const editorState = store.getEditorState();
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();
	const endBlock = content.getBlockForKey(selection.getEndKey());
	const text = getSelectedText(editorState);
	const replaceRange = new SelectionState({
		anchorKey: selection.getStartKey(),
		anchorOffset: 0,
		focusKey: selection.getEndKey(),
		focusOffset: endBlock.getLength()
	});
	const codeBlock = new ContentBlock({
		key: genKey(),
		type: 'code-block',
		data: Map({
			syntax: 'js'
		}),
		text,
		// https://github.com/facebook/draft-js/blob/ab03fdda5fb6fe3c189176979fef8c3e16eb39a5/src/model/immutable/ContentState.js#L204
		characterList: List(Repeat(CharacterMetadata.EMPTY, text.length))
	});
	// 没有 emptyBlock 的话 blockType 会被忽略
	const emptyBlock = new ContentBlock({
		key: genKey(),
		type: 'unstyled',
		text: '',
		characterList: List()
	});
	const fragment = BlockMapBuilder.createFromArray([codeBlock]);
	const withFragment = Modifier.replaceWithFragment(content, replaceRange, fragment);
	const withFragmentPushed = EditorState.push(editorState, withFragment , 'insert-fragment');
	const withCodeType = RichUtils.toggleBlockType(withFragmentPushed, 'code-block')
	store.setEditorState(withCodeType);
}




// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/blockStylePlugin/CodeBlockButton.jsx